import { render, staticRenderFns } from "./superadminpage.vue?vue&type=template&id=91bb978c&scoped=true&"
import script from "./superadminpage.vue?vue&type=script&lang=js&"
export * from "./superadminpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91bb978c",
  null
  
)

export default component.exports